export const cEstadoVenta = {
    noDisponible: -1,
    creado: 0,
    habilitado: 1,
    deshabilitado: 2,
    bloqueado: 3,
    noVerificado: 4,
    restableciendoPassword: 5,
    emitido: 6,
    anulado: 7,
    certificado: 8,
    enProceso: 9,
    fallida: 10,
    aprobado: 14,
    reprobado: 15,
    cancelado: 16,
    pendientePago: 17,
    pagada: 18,
    abierta: 19,
    cerrada: 20,
    actualizado: 21,
    terminado: 22,
    pendienteAprobacion: 23,
    pendienteAprobacionPrecios: 24,
    pendienteAprobacionVehiculos:35,
    pendienteAprobacionListaPrecios: 43,
    pendienteIve:39,
    preCierre: 25,
    reportado: 26,
    procesoAprobacionCredito: 27,
    nuevo: 80,
    procesoAprobacionPrecios: 30,
    procesoCambioDevolucion: 32,
    disponible:81,
    reservado:82,
    vendido:83,
    retirado:85,
    cambiadoPorDevolucion:34,
    naCertifacion:811,
};


export const cEstadoCompra = {
    nueva: 500,
    pendienteSeleccionProveedor: 501,
    cotizacionProveedorUnico: 502,
    proveedorSeleccionado: 503,
    canceladaSinPo: 504,
    ordenDeCompra: 505,
    cancelada: 506,
    pendienteRecibirEntregable: 507,
    confirmacionProveedor: 508,
    finalizada: 509,
    pendienteActualizarPrecio: 510,
};

export const cEstadoCompraPedido = {
    nueva: 540,
  enProceso: 541,
  cancelada: 542,
  finalizada: 543,
};